export default __webpack_public_path__ + "static/media/ic_arrowBack_light.b19a6aef.svg";